import { handleError } from "../../Utils/apiUtil";
export function apiCallerNew(url, method, params, token) {
  var options = {};

  options.method = method;

  var headers = {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: 'Bearer '+ token,
  };
  var query = "";
  if (params && Object.keys(params).length > 0) {
    if (method == "POST") {
      options.headers = headers;
      options.body = JSON.stringify(params);
    } else if (method == "PUT") {
      options.headers = headers;
      options.body = JSON.stringify(params);
    } else {
      query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");
    }
  }

  return new Promise((resolve, reject) => {
    if (method === "POST") {
      options.headers = headers;
      options.body = JSON.stringify(params);
      //console.log("opt",options)
      fetch(url, options)
        .then((response) => {
          if (response.status === 200) {
            response.json().then((json) => {
              return resolve(json);
            });
          }
          if (response.status === 400) {
            response.json().then((json) => {
              reject(json);
            });
          }
        })
        .catch(handleError);
    } else if (method == "PUT") {
      options.headers = headers;
      fetch(url, options)
        .then((response) => {
          if (response.status === 200) {
            response.json().then((json) => {
              return resolve(json);
            });
          }
          if (response.status === 400) {
            response.json().then((json) => {
              reject(json);
            });
          }
        })
        .catch(handleError);
    } else {
      options.headers = headers;
      fetch(url + query, options)
        .then((response) => {
          if (response.status === 200) {
            response.json().then((json) => {
              return resolve(json);
            });
          }
          if (response.status === 400) {
            response.json().then((json) => {
              resolve(json);
            });
          }
        })
        .catch(handleError);
    }
  });
}
